import { css } from '@emotion/css';

import { mobileMediaQuery, nonMobileMediaQuery } from '../../constants';
import { m } from '../../motif/m';
import { FontFamily } from '../Font/fontConstants';

export const bigQuoteCss = css`
  font-size: 40px;
  line-height: 40px;
  margin-bottom: -20px;
  margin-top: -8px;
  text-align: start;
`;

export const startQuoteCss = css`
  margin-inline-start: -16px;
  text-align: start;
`;

export const endQuoteCss = css`
  margin-inline-end: -20px;
  text-align: end;
`;

export const quoteCss = css`
  padding: ${m('--spacing-xl')};
  border-radius: ${m('--border-radius-l')};

  background-color: ${m('--quote-bg-color')};
  color: ${m('--quote-fg-color')};
  box-shadow: ${m('--box-shadow-s')};
  font-family: ${m('--h5-font-family')};
  font-size: ${m('--h5-desktop-font-size')};
  font-weight: ${m('--h5-desktop-font-weight')};
  line-height: 120%;

  ${nonMobileMediaQuery} {
    width: 580px;
  }

  ${mobileMediaQuery} {
    width: 100%;
  }
`;

export const quoteIconCss = css`
  font-family: ${FontFamily.PROGRAM_OT}, Helvetica, Tahoma, Arial, sans-serif;
  color: ${m('--action-text-active-color')};
  font-size: 150px;
  line-height: 160px;
  margin-bottom: -60px;
`;

export const quoteTextCss = css`
  display: block;
  clear: both;
`;

export const longQuoteTextCss = css`
  font-family: ${m('--font-family')};
  font-size: ${m('--p1-desktop-font-size')};
  font-weight: ${m('--p1-desktop-font-weight')};
  line-height: 120%;
`;

export const imageButtonContainerCss = css`
  display: flex;
  justify-content: flex-end;
`;

export const authorCss = css`
  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  text-align: end;

  ${nonMobileMediaQuery} {
    font-size: ${m('--quote-author-desktop-font-size')};
    font-weight: ${m('--quote-author-desktop-font-weight')};
  }

  ${mobileMediaQuery} {
    font-size: ${m('--quote-author-mobile-font-size')};
    font-weight: ${m('--quote-author-mobile-font-weight')};
  }
`;

export const authorWithoutLogoCss = css`
  ${authorCss}
  margin-top: ${m('--spacing-l')};
`;
